import React from 'react'
import { VideoLoader } from '../VideoLoader'
import { VideoAudioTracks } from './VideoAudioTracks'
import { VideoClosedCaptions } from './VideoClosedCaptions'
import { VideoContainer } from './VideoContainer'
import { VideoFullscreen } from './VideoFullscreen'
import { VideoPlayback } from './VideoPlayback'
import { VideoScrubber } from './VideoScrubber'
import { VideoSpacer } from './VideoSpacer'
import { VideoVolume } from './VideoVolume'

/**
 * A limited set of controls for a smaller video player.
 * Includes a loader, progress bar, play/pause, volume,
 * cc, audio tracks, and fullscreen controls
 */
export const VideoControlsSmall = () => (
  <>
    <VideoLoader />
    <VideoContainer>
      <VideoScrubber />
      <VideoPlayback />
      <VideoVolume />
      <VideoSpacer />
      <VideoClosedCaptions />
      <VideoAudioTracks />
      <VideoFullscreen />
    </VideoContainer>
  </>
)
